export default function usersReducer(
    state: any = {
        users: {
            loading: false,
            done: false,
            users: [],
            error: null,
            success: null,
        },
        userInformation: {
            loading: false,
            done: false,
            response: null,
            error: null,
            success: null,
        },
        deactivateUser: {
            loading: false,
            done: false,
            response: null,
            error: null,
            success: null,
        },
    },
    action: any) {

    switch (action.type) {

        /**
         *     Listing users reducers
         */
        case 'FETCH_USERS_PENDING': {
            return { ...state, users: { ...state.users, loading: true } }
        }

        case 'FETCH_USERS_REJECTED': {
            return { ...state, users: { ...state.users, loading: false, error: action.payload } }
        }

        case 'FETCH_USERS_FULFILLED': {
            return {
                ...state, users: {
                    ...state.users, loading: false, done: true, error: null, users: action.payload, success: null,
                },
            }
        }

        /**
         *     Add new user reducers
         */
        case 'ADD_NEWUSER_PENDING': {
            return { ...state }
        }

        case 'ADD_NEWUSER_REJECTED': {
            return { ...state, users: { ...state.users, error: action.payload, success: null } }
        }

        case 'ADD_NEWUSER_FULFILLED': {
            return { ...state, users: { ...state.users, error: null, success: true } }
        }

        /**
         *     Add new user reducers
         */
        case 'FETCH_USER_AGENCY_DETAIL_PENDING': {
            return { ...state, userInformation: { ...state.userInformation, loading: true } }
        }

        case 'FETCH_USER_AGENCY_DETAIL_REJECTED': {
            return { ...state, userInformation: { ...state.userInformation, loading: false, error: action.payload } }
        }

        case 'FETCH_USER_AGENCY_DETAIL_FULFILLED': {
            return {
                ...state, userInformation: {
                    ...state.userInformation,
                    loading: false,
                    done: true,
                    error: null,
                    response: action.payload,
                    success: null,
                },
            }
        }

        /**
         *     Add new user reducers
         */
        case 'DEACTIVATE_USER_PENDING': {
            return { ...state, deactivateUser: { ...state.deactivateUser, loading: true } }
        }

        case 'DEACTIVATE_USER_REJECTED': {
            return { ...state, deactivateUser: { ...state.deactivateUser, loading: false, error: action.payload } }
        }

        case 'DEACTIVATE_USER_FULFILLED': {
            return {
                ...state, deactivateUser: {
                    ...state.deactivateUser,
                    loading: false,
                    done: true,
                    error: null,
                    response: action.payload,
                    success: null,
                },
            }
        }

        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/users.ts